"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logout = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Logout = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { className: "logout", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24", style: style },
        React.createElement("defs", null,
            React.createElement("path", { id: "LOGOUT_SVG_ICON_PATH", 
                // tslint:disable-next-line:max-line-length
                d: "M7.4 6H12v2h2V5c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v9c0 .3.1.5.3.7l5 5c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.1.6-.5.6-.9v-9c0-.3-.1-.5-.3-.7L7.4 6zM9 16.6l-3-3V7.4l3 3v6.2zm10.7-5.3c.4.4.4 1 0 1.4L16 16.4 14.6 15l2-2H12v-2h4.6l-2-2L16 7.6l3.7 3.7z" })),
        React.createElement("g", { fill: color, fillRule: "evenodd" },
            React.createElement("mask", { id: "LOGOUT_SVG_ICON_MASK", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#LOGOUT_SVG_ICON_PATH" })),
            React.createElement("g", { mask: "url(#LOGOUT_SVG_ICON_MASK)" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
};
exports.Logout = Logout;
//# sourceMappingURL=Logout.js.map